import { Center, Pagination } from '@mantine/core';
import { FC } from 'react';
import { ThemeText } from '../../Atoms/ThemeText';

interface Props {
  pageSize: number;
  pageNumber: number;
  totalCount: number;
  totalPages: number;
  entityName: string;
  onChange: (pageNumber: number) => void;
  disabled?: boolean;
}

const PaginationNav: FC<Props> = ({ pageNumber, pageSize, totalCount, totalPages, entityName, onChange, disabled }) => (
  <div>
    <Center mt="xl" mb="sm">
      <Pagination
        noWrap
        disabled={disabled}
        boundaries={1}
        siblings={0}
        total={totalPages}
        page={pageNumber + 1}
        onChange={onChange}
      />
    </Center>
    {totalCount > 0 && (
      <Center>
        <ThemeText weight="lighter">{`${pageSize * pageNumber + 1} - ${
          pageSize * (pageNumber + 1) < totalCount ? pageSize * (pageNumber + 1) : totalCount
        } von ${totalCount} ${entityName}`}</ThemeText>
      </Center>
    )}
  </div>
);

export default PaginationNav;
